import styled from "styled-components";
import Link from "@/common/UI/Link";

const SeparatorBtn = (props) => {
  const { text, slug, siteConfig } = props;
  const HoverBg = styled.a`
    a {
      &:hover {
        background: ${siteConfig?.brandButtonHoverColor?.hex} !important;
      }
      &:active {
        background: ${siteConfig?.brandButtonPressedColor?.hex} !important;
      }
    }
  `;
  return (
    <div className="block w-full text-center my-20 relative before:absolute before:w-1/2 before:left-0 before:top-2.5 before:border before:border-light after:absolute after:w-1/2 after:right-0 after:top-2.5 after:border after:border-light">
      <HoverBg>
        <Link
          href={slug || "/"}
          style={{
            backgroundColor: siteConfig?.brandButtonDefaultColor?.hex,
          }}
          className="btn  text-white py-2.5 px-10 font-bold relative z-10"
        >
          {text}
        </Link>
      </HoverBg>
    </div>
  );
};
export default SeparatorBtn;
